import { ConfigInterface } from 'client/Interfaces/Draft/v1/DraftInterface'

import { CompanyInterface } from '../../Interfaces/CompanyInterface'
import { DocumentType, InvoicerInterface } from '../../Interfaces/Draft/DraftInterface'
import { SummaryInterface } from '../../Interfaces/Draft/v1/SummaryInterface'
import { ModelInterface } from '../../Interfaces/Settings/ModelInterface'
import { SettingsInterface } from '../../Interfaces/Settings/SettingsInterface'
import { TokenInterface } from '../../Interfaces/TokenInterface'

export const getModel = (settings: SettingsInterface, document: DocumentType): ModelInterface => {
  return settings.models.filter((model) => {
    return model.type === document
  })[0]
}

export const getTradeName = (settings: SettingsInterface, documentType: DocumentType) => {
  const model = getModel(settings, documentType)
  // always first check the default === true, otherwise take the sender one
  // if it still failes take the first one as default
  const tradeNames = settings.values.company.tradeNames
  const senderField = model.fields.filter((f) => {
    return f.name === 'sender'
  })[0]
  const sender = senderField && senderField.default
  let tradeName
  let senderName
  if (tradeNames && tradeNames.length > 1) {
    tradeNames.forEach((name) => {
      if (name.default === true) {
        tradeName = name
      }
      if (name._id === sender) {
        senderName = name
      }
    })

    if (!tradeName && senderName) {
      tradeName = senderName
    }

    if (!tradeName) {
      tradeName = tradeNames[0]
    }
  } else {
    tradeName = tradeNames[0]
  }
  return tradeName
}

export const getCompany = (
  settings: SettingsInterface,
  company: CompanyInterface,
  { country }: TokenInterface,
  documentType: DocumentType,
): InvoicerInterface => {
  const tradeName = getTradeName(settings, documentType)
  const { rcs = '', legalStatus = '', hrNr, amtsgericht, taxPrepaymentRegistered } = settings.values.company
  const hrNrProp = hrNr ? { hrNr } : {}
  const amtsgerichtProp = amtsgericht ? { amtsgericht } : {}
  const ftaxProp = typeof taxPrepaymentRegistered === 'boolean' ? { taxPrepaymentRegistered } : {}
  const invoicer: InvoicerInterface = {
    tradeName: { ...tradeName, country },
    vatNumber: company.vatNumber,
    businessId: company.businessId,
    rcs,
    legalStatus,
    id: company.id,
    ...hrNrProp,
    ...amtsgerichtProp,
    ...ftaxProp,
  }
  return company
}

export const getSummary = (config: ConfigInterface): SummaryInterface => {
  return {
    foreignGrossTotal: 0,
    foreignNetTotal: 0,
    foreignTaxTotal: 0,
    foreignCurrency: config.fields.currency.value,
    localCurrency: config.fields.currency.value,
    localGrossTotal: 0,
    localNetTotal: 0,
    localTaxTotal: 0,
    exchangeRate: 1,
  }
}
